export default "/assets/images/technology-hero-sm.d43de2e7961a8a69.jpg";